import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  TopBanner, // Add this new styled component
  MainHeader,
  PromoBanner,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  // const [currentSlide, setCurrentSlide] = useState(0);
  const [topCurrentSlide, setTopCurrentSlide] = useState(0);

  // Top banner data (all 3 messages)
  const topBannerData = [
    // "Horários flexíveis 24/7 - Agende sua consulta no horário que funciona para você",
    "Terapia online em português - Atendimento especializado para brasileiros no mundo todo ",
    "Horários flexíveis 24/7 - Agende sua consulta no horário que funciona para você"
  ];

  // Bottom banner data (only $25 therapy message)
  const bottomBannerData = "Consulta inicial por apenas $25 com os melhores profissionais do Brasil";

  const toggleButton = () => {
    setVisibility(!visible);
  };

  // const nextSlide = () => {
  //   setCurrentSlide((prev) => (prev + 1) % topBannerData.length);
  // };

  // const previousSlide = () => {
  //   setCurrentSlide((prev) => (prev - 1 + topBannerData.length) % topBannerData.length);
  // };

  const nextTopSlide = () => {
    setTopCurrentSlide((prev) => (prev + 1) % topBannerData.length);
  };

  const previousTopSlide = () => {
    setTopCurrentSlide((prev) => (prev - 1 + topBannerData.length) % topBannerData.length);
  };

  // Auto-slide functionality for top banner
  useState(() => {
    const interval = setInterval(() => {
      nextTopSlide();
    }, 4000);
    return () => clearInterval(interval);
  });

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{t("Sobre")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
          <Span>{t("Missão")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("product")}>
          <Span>{t("Serviços")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => scrollTo("contact")}
        >
          <Span>
            <Button>{t("Contato")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      {/* Top Banner - Shows all 3 messages */}
      <TopBanner>
        <div className="banner-content">
          <span className="banner-text">{topBannerData[topCurrentSlide]}</span>
        </div>
        <button className="banner-nav prev" onClick={previousTopSlide}>‹</button>
        <button className="banner-nav next" onClick={nextTopSlide}>›</button>
      </TopBanner>

      {/* Main Header */}
      <MainHeader>
        <Container>
          <Row justify="space-between">
            <LogoContainer to="/" aria-label="homepage">
              <SvgIcon src="Belomind_transparent.svg" width="250px" height="80px" />
            </LogoContainer>
            <NotHidden>
              <MenuItem />
            </NotHidden>
            <Burger onClick={toggleButton}>
              <Outline />
            </Burger>
          </Row>
          <Drawer closable={false} open={visible} onClose={toggleButton}>
            <Col style={{ marginBottom: "2.5rem" }}>
              <Label onClick={toggleButton}>
                <Col span={12}>
                  <Menu>Menu</Menu>
                </Col>
                <Col span={12}>
                  <Outline />
                </Col>
              </Label>
            </Col>
            <MenuItem />
          </Drawer>
        </Container>
      </MainHeader>

      {/* Bottom Banner - Shows only $25 therapy message in bold */}
      <PromoBanner>
        <div className="banner-content">
          <span className="banner-text bold">{bottomBannerData}</span>
        </div>
      </PromoBanner>
    </HeaderSection>
  );
};

export default withTranslation()(Header);